/**
 * Describes the different events that can be emitted by the module.
 */
export var Event;
(function (Event) {
    /**
     * Native Events
     */
    Event["KEY_SESSION_MESSAGE"] = "message";
    Event["KEY_SESSION_STATUSES_CHANGE"] = "keystatuseschange";
    Event["MEDIA_SOURCE_OPEN"] = "sourceopen";
    Event["MEDIA_SOURCE_CLOSE"] = "sourceclose";
    Event["SOURCE_BUFFER_UPDATE_END"] = "updateend";
    /**
     * MS EME Events
     */
    Event["MS_KEY_ADDED"] = "mskeyadded";
    Event["MS_KEY_ERROR"] = "mskeyerror";
    Event["MS_KEY_MESSAGE"] = "mskeymessage";
    Event["MS_NEEDKEY"] = "msneedkey";
    // Safari EME Events
    Event["WEBKIT_KEY_ADDED"] = "webkitkeyadded";
    Event["WEBKIT_KEY_ERROR"] = "webkitkeyerror";
    Event["WEBKIT_KEY_MESSAGE"] = "webkitkeymessage";
    Event["WEBKIT_NEEDKEY"] = "webkitneedkey";
    /**
     * WebKit EME Events
     */
    Event["V0_1B_KEY_ADDED"] = "keyadded";
    Event["V0_1B_KEY_ERROR"] = "keyerror";
    Event["V0_1B_KEY_MESSAGE"] = "keymessage";
    Event["V0_1B_NEEDKEY"] = "needkey";
    Event["MEDIA_CANPLAY"] = "canplay";
    Event["MEDIA_CANPLAYTHROUGH"] = "canplaythrough";
    Event["MEDIA_DURATIONCHANGE"] = "durationchange";
    Event["MEDIA_ENCRYPTED"] = "encrypted";
    Event["MEDIA_ENDED"] = "ended";
    Event["MEDIA_ERROR"] = "error";
    Event["MEDIA_LOADEDMETADATA"] = "loadedmetadata";
    Event["MEDIA_PAUSE"] = "pause";
    Event["MEDIA_PLAYING"] = "playing";
    Event["MEDIA_SEEKING"] = "seeking";
    Event["MEDIA_TIMEUPDATE"] = "timeupdate";
    Event["MEDIA_WAITING"] = "waiting";
    /**
     * Internal Events
     */
    Event["INTERNAL_ENCRYPTED"] = "__encrypted";
    Event["INTERNAL_PLAYER_CANPLAY"] = "__canplay";
    Event["INTERNAL_PLAYER_CANPLAYTHROUGH"] = "__canplaythrough";
    Event["INTERNAL_MEDIA_REQUIRES_DURATION"] = "__requiresduration";
    Event["INTERNAL_PLAYER_LOADED_METADATA"] = "__loadedmetadata";
    /**
     * Buffer events
     */
    Event["BUFFER_APPEND_ERROR"] = "append_error";
    Event["BUFFER_QUOTA_EXCEEDED"] = "quota_exceeded";
    Event["BUFFER_STALLED"] = "stalled";
    Event["BUFFER_SOURCE_OPEN"] = "source_open";
    Event["BUFFER_SOURCE_CLOSE"] = "source_close";
    Event["BUFFERING_START"] = "buffering_start";
    Event["BUFFERING_END"] = "buffering_end";
    /**
     * EME Manager
     */
    Event["EME_LICENSE_REQUEST_ERROR"] = "license_request_error";
    Event["EME_LICENSE_REQUEST_CAPPED"] = "license_request_capped";
    /**
     * List Player
     */
    Event["LIST_PLAYER_AUTOPLAY_FAILED"] = "player_autoplay_failed";
    Event["LIST_PLAYER_BEFORE_LIST_CHANGE"] = "before_list_change";
    Event["LIST_PLAYER_BEFORE_NEXT"] = "before_next";
    Event["LIST_PLAYER_BEFORE_PLAYER_LOAD"] = "before_player_load";
    Event["LIST_PLAYER_BEFORE_PREVIOUS"] = "before_previous";
    Event["LIST_PLAYER_BEFORE_TRACK_LOAD"] = "before_track_load";
    Event["LIST_PLAYER_BEFORE_VOLUME_CHANGE"] = "before_volume_change";
    Event["LIST_PLAYER_BUFFER_STALLED"] = "stalled";
    Event["LIST_PLAYER_BUFFERING_START"] = "buffering_start";
    Event["LIST_PLAYER_BUFFERING_END"] = "buffering_end";
    Event["LIST_PLAYER_CAPPED"] = "capped";
    Event["LIST_PLAYER_CLEARED"] = "cleared";
    Event["LIST_PLAYER_DURATION_CHANGED"] = "duration_changed";
    Event["LIST_PLAYER_ERROR"] = "error";
    Event["LIST_PLAYER_ERROR_SYNC"] = "error_sync";
    Event["LIST_PLAYER_LIST_CHANGED"] = "list_change";
    Event["LIST_PLAYER_LIST_ENDED"] = "list_ended";
    Event["LIST_PLAYER_LOAD_VIDEO"] = "load_video";
    Event["LIST_PLAYER_MAX_LIST_ERRORS_REACHED"] = "max_list_errors_reached";
    Event["LIST_PLAYER_PAUSED"] = "paused";
    Event["LIST_PLAYER_PLAYED_THRESHOLD_REACHED"] = "played_threshold_reached";
    Event["LIST_PLAYER_PLAYER_LOAD"] = "player_load";
    Event["LIST_PLAYER_PLAYING"] = "playing";
    Event["LIST_PLAYER_POSITION_CHANGED"] = "position_changed";
    Event["LIST_PLAYER_PROGRESS"] = "progress";
    Event["LIST_PLAYER_REPEAT_MODE_CHANGED"] = "repeat_mode_changed";
    Event["LIST_PLAYER_SHUFFLE_CHANGED"] = "shuffle_changed";
    Event["LIST_PLAYER_STOPPED"] = "stopped";
    Event["LIST_PLAYER_STOPPED_VIDEO"] = "stopped_video";
    Event["LIST_PLAYER_TRACKING_DATA_CREATED"] = "tracking_data_created";
    Event["LIST_PLAYER_TRACKING_DATA_FINALIZED"] = "tracking_data_finalized";
    Event["LIST_PLAYER_TRACK_ENDED"] = "track_ended";
    Event["LIST_PLAYER_TRACK_LOADED"] = "track_loaded";
    Event["LIST_PLAYER_TRACK_TIMEOUT"] = "track_timeout";
    Event["LIST_PLAYER_TRACK_UNPLAYABLE"] = "track_unplayable";
    Event["LIST_PLAYER_DATA_CREATED"] = "tracking_data_created";
    Event["LIST_PLAYER_DATA_FINALIZED"] = "tracking_data_finalized";
    Event["LIST_PLAYER_VOLUME_CHANGED"] = "volume_changed";
    Event["LIST_PLAYER_VIDEO_ELEMENT_APPENDED"] = "video_element_appended";
    Event["LIST_PLAYER_VIDEO_ELEMENT_REMOVED"] = "video_element_removed";
    /**
     * Logger
     */
    Event["LOGGER_ERROR"] = "error";
    /**
     * Player
     */
    Event["PLAYER_AUTOPLAY_FAILED"] = "player_autoplay_failed";
    Event["PLAYER_BEFORE_LOAD"] = "before_load";
    Event["PLAYER_BEFORE_STOP"] = "before_stop";
    Event["PLAYER_BEFORE_VOLUME_CHANGE"] = "before_volume_change";
    Event["PLAYER_BUFFER_STALLED"] = "stalled";
    Event["PLAYER_BUFFERING_START"] = "buffering_start";
    Event["PLAYER_BUFFERING_END"] = "buffering_end";
    Event["PLAYER_CAN_PRELOAD"] = "can_preload";
    Event["PLAYER_CAPPED"] = "capped";
    Event["PLAYER_DURATION_CHANGED"] = "duration_changed";
    Event["PLAYER_ENDED"] = "ended";
    Event["PLAYER_ENDED_VIDEO"] = "ended_video";
    Event["PLAYER_ERROR"] = "error";
    Event["PLAYER_WARNING"] = "warning";
    Event["PLAYER_FIRST_BYTES"] = "first_bytes";
    Event["PLAYER_KEY_RECEIVED"] = "key";
    Event["PLAYER_LOAD"] = "load";
    Event["PLAYER_LOAD_VIDEO"] = "load_video";
    Event["PLAYER_LOADING_FAILED"] = "loading_failed";
    Event["PLAYER_PAUSED"] = "paused";
    Event["PLAYER_PLAYING"] = "playing";
    Event["PLAYER_POSITION_CHANGED"] = "position_changed";
    Event["PLAYER_PRELOADING_ERROR"] = "preloading_error";
    Event["PLAYER_PROGRESS"] = "progress";
    Event["PLAYER_STALLED"] = "stalled";
    Event["PLAYER_STOPPED"] = "stopped";
    Event["PLAYER_STOPPED_VIDEO"] = "stopped_video";
    Event["PLAYER_PLAYED_THRESHOLD_REACHED"] = "played_threshold_reached";
    Event["PLAYER_TIMEOUT"] = "timeout";
    Event["PLAYER_PLAYBACK_START"] = "playback_start";
    Event["PLAYER_TRACKING_DATA_CREATED"] = "tracking_data_created";
    Event["PLAYER_TRACKING_DATA_FINALIZED"] = "tracking_data_finalized";
    Event["PLAYER_VIDEO_ELEMENT_APPENDED"] = "video_element_appended";
    Event["PLAYER_VIDEO_ELEMENT_REMOVED"] = "video_element_removed";
    /**
     * PlayerManager
     */
    Event["PLAYER_MANAGER_READY"] = "ready";
    /**
     * Tracker
     */
    Event["TRACKER_PLAYBACK_START"] = "playback_start";
    Event["TRACKER_PLAYED_THRESHOLD_REACHED"] = "played_threshold_reached";
    Event["TRACKER_TRACKING_DATA_CREATED"] = "tracking_data_created";
    Event["TRACKER_TRACKING_DATA_FINALIZED"] = "tracking_data_finalized";
    Event["ABR_MANAGER_BITRATE_CHANGE"] = "bitrate_change";
})(Event || (Event = {}));
//# sourceMappingURL=event.js.map